module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"BBF":"Dark Brown","BB":"Brown","BF":"Dark Bay","B":"Bay","AUB":"Strawberry Roan","AF":"Dark Chestnut","AL":"Chestnut","NME":"Mixed Black","NP":"Seal Brown","xx":"Unknown","RO":"Roan","N":"Black","GRR":"Grey Roan","GRF":"Dark Grey","GR":"Grey"}}')
  delete Component.options._Ctor
}
